<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addCompanyUser')"
        :rules="rulesForm"
        :submit="submit">
        <div class="p-4">
            <hts-form-radio
                v-model="formData.registerBy"
                label="Đăng ký bằng"
                :items="registerByItems"
                required
                value-key="key"
                label-key="label" />
            <hts-form-input
                v-if="formData.registerBy === 'email'"
                v-model="formData.email"
                :label="$t('labels.emailRegister')"
                required
                prop="emailRegister"
                name="emailRegister" />
            <hts-form-phone
                v-if="formData.registerBy === 'phone'"
                v-model="formData.phone"
                :label="$t('labels.phoneRegister')"
                autocomplete
                required
                name="phoneRegister"
                prop="phoneRegister" />

            <hts-form-input
                v-model="formData.fullName"
                :label="$t('labels.fullName')"
                :required="true"
                prop="fullName" />

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-1">
                <hts-form-select
                    v-model="formData.group"
                    :label="$t('labels.companyGroup')"
                    :items="listCompanyGroup"
                    key-id="_id"
                    :required="true"
                    key-label="name"
                    prop="group"
                    name="group" />
                <hts-form-input
                    v-model="formData.jobTitle"
                    :label="$t('labels.jobTitle')"
                    prop="jobTitle" />
            </div>
            <hts-form-phone
                v-model="formData.contactPhoneNumber"
                :label="$t('labels.contactPhoneNumber')"
                autocomplete
                required
                name="contactPhoneNumber"
                prop="contactPhoneNumber" />
            <hts-form-input
                v-model="formData.address"
                :label="$t('labels.address')"
                prop="address" />
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
import data from '../-components/imports/data'
const creating = ref(false)
const props = defineProps({
  listCompanyGroup: {
    type: Array,
    default: () => []
  },
  listCompanyUser: {
    type: Array,
    default: () => []
  }
})
const visible = ref(false)
const formData = reactive({
  registerBy: 'email',
  group: '',
  fullName: '',
  address: '',
  phone: {
    code: '+84',
    phone: '',
    countryCode: 'Vietnam +84'
  },
  contactPhoneNumber: {
    code: '+84',
    phone: '',
    countryCode: 'Vietnam +84'
  },
  jobTitle: '',
  email: ''
})

const { registerByItems } = data()
const open = (dataDefault?: { [key: string]: any }) => {
  if (dataDefault) {
    Object.assign(formData, dataDefault)

    if (formData.phone) {
      formData.registerBy = 'phone'
    }
  }
  visible.value = true
}

defineExpose({
  open
})

const rulesForm = computed(() => {
  const rules = {
    fullName: 'required',
    group: 'required',
    contactPhoneNumber: 'required'
  } as { [key: string]: any }

  if (formData.registerBy === 'email') {
    rules.emailRegister = 'required|email'
  } else {
    rules.phoneRegister = 'required'
  }

  return rules
})

const emits = defineEmits(['refreshTables', 'newData'])

const resetForm = () => {
  Object.assign(formData, {
    registerBy: 'email',
    group: '',
    fullName: '',
    address: '',
    phone: {
      code: '+84',
      phone: '',
      countryCode: 'Vietnam +84'
    },
    contactPhoneNumber: {
      code: '+84',
      phone: '',
      countryCode: 'Vietnam +84'
    },
    jobTitle: '',
    email: ''
  })
}

const submit = async () => {
  const api = {
    url: '/company/user/create',
    method: 'post'
  }

  const { registerBy, email, phone, fullName, address, jobTitle, group, contactPhoneNumber } = formData
  const body = {
    registerBy,
    fullName,
    address,
    jobTitle,
    groupId: group,
    contactPhoneNumber
  } as { [key: string]: any }

  if (email && registerBy === 'email') {
    body.email = email
  }

  if (phone && phone.phone && registerBy === 'phone') {
    body.phone = phone
  }

  creating.value = true
  const { data }: any = await $api(api, { body })
  if (data.value.success) {
    process.client && $toast().success($t('labels.addCompanyUserSuccess'))
    emits('refreshTables')
    emits('newData', data?.value?.data)
    visible.value = false
    resetForm()
  }
}
</script>
